const toNormalizedObject = (value) => {
  if (!value || typeof value !== 'object') {
    return {};
  }

  return Object.keys(value)
    .sort()
    .reduce((acc, key) => {
      const current = value[key];
      if (current === undefined || current === null || current === '') {
        return acc;
      }

      if (Array.isArray(current)) {
        if (current.length === 0) {
          return acc;
        }
        acc[key] = [...current].sort();
        return acc;
      }

      acc[key] = current;
      return acc;
    }, {});
};

export const runtimeQueryKeys = {
  root: ['runtime'],

  schedulerHealth: (filters = {}) => [
    ...runtimeQueryKeys.root,
    'scheduler',
    'health',
    toNormalizedObject(filters),
  ],

  schedulerDiagnostics: (filters = {}) => [
    ...runtimeQueryKeys.root,
    'scheduler',
    'diagnostics',
    toNormalizedObject(filters),
  ],

  schedulerRuns: (filters = {}) => [
    ...runtimeQueryKeys.root,
    'scheduler',
    'runs',
    toNormalizedObject(filters),
  ],

  diagnosticsMetrics: (filters = {}) => [
    ...runtimeQueryKeys.root,
    'diagnostics',
    'metrics',
    toNormalizedObject(filters),
  ],

  recoveryDiagnostics: (filters = {}) => [
    ...runtimeQueryKeys.root,
    'diagnostics',
    'recovery',
    toNormalizedObject(filters),
  ],

  recoveryStuckRequests: (filters = {}) => [
    ...runtimeQueryKeys.root,
    'diagnostics',
    'recovery-stuck-requests',
    toNormalizedObject(filters),
  ],

  recoveryAgingBuckets: (filters = {}) => [
    ...runtimeQueryKeys.root,
    'diagnostics',
    'recovery-aging-buckets',
    toNormalizedObject(filters),
  ],

  recoverySummary: (filters = {}) => [
    ...runtimeQueryKeys.root,
    'diagnostics',
    'recovery-summary',
    toNormalizedObject(filters),
  ],

  retryPreview: (filters = {}) => [
    ...runtimeQueryKeys.root,
    'retry',
    'preview',
    toNormalizedObject(filters),
  ],

  retryPlanPreview: (filters = {}) => [
    ...runtimeQueryKeys.root,
    'retry',
    'plan-preview',
    toNormalizedObject(filters),
  ],

  executionsList: (filters = {}) => [
    ...runtimeQueryKeys.root,
    'history',
    'executions',
    toNormalizedObject(filters),
  ],

  executionsSearch: (filters = {}) => [
    ...runtimeQueryKeys.root,
    'history',
    'search',
    toNormalizedObject(filters),
  ],

  executionDetail: (executionId) => [
    ...runtimeQueryKeys.root,
    'history',
    'execution-detail',
    String(executionId || ''),
  ],

  executionTimeline: (executionId) => [
    ...runtimeQueryKeys.root,
    'history',
    'execution-timeline',
    String(executionId || ''),
  ],

  reconciliationByExecution: (executionId) => [
    ...runtimeQueryKeys.root,
    'reconciliation',
    'execution',
    String(executionId || ''),
  ],

  reconciliationByInvoice: (invoiceId) => [
    ...runtimeQueryKeys.root,
    'reconciliation',
    'invoice',
    String(invoiceId || ''),
  ],

  reconciliationByCharge: (chargeId) => [
    ...runtimeQueryKeys.root,
    'reconciliation',
    'charge',
    String(chargeId || ''),
  ],

  reconciliationByTenant: (tenantId) => [
    ...runtimeQueryKeys.root,
    'reconciliation',
    'tenant',
    String(tenantId || ''),
  ],

  providerGlobalConfig: () => [...runtimeQueryKeys.root, 'provider-config', 'global'],

  providerCatalog: (filters = {}) => [
    ...runtimeQueryKeys.root,
    'provider-config',
    'catalog',
    toNormalizedObject(filters),
  ],

  providerTenantConfig: (tenantId) => [
    ...runtimeQueryKeys.root,
    'provider-config',
    'tenant',
    String(tenantId || ''),
  ],
};

export default runtimeQueryKeys;